import { isBoolean, isFunction } from 'lodash';
import React from 'react';
import styled from 'styled-components';

import Button from '../Button';
import OnClickOutside from '../OnClickOutside';
import { AbstractDropdownProps } from './types';

interface State {
  isOpen: boolean;
}

class AbstractDropdown extends React.PureComponent<
  Readonly<AbstractDropdownProps>,
  State
> {
  static StyledContentContainer: any;

  dropdownRef?: React.RefObject<any>;

  constructor(props) {
    super(props);

    this.state = {
      isOpen: Boolean(props.open),
    };

    this.dropdownRef = React.createRef();

    this.handleBlur = this.handleBlur.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { isOpen } = this.state;
    if (isBoolean(nextProps.open) && nextProps.open !== isOpen) {
      this.setState(() => ({ isOpen: nextProps.open }));
    }
    return null;
  }

  handleBlur({ relatedTarget }) {
    const { autoClose } = this.props;

    if (autoClose && !this.dropdownRef?.current?.contains(relatedTarget)) {
      this.toggle(false);
    }
  }

  handleClick() {
    this.toggle();
  }

  handleFocus() {
    const { autoOpen } = this.props;
    if (autoOpen) {
      this.toggle(true);
    }
  }

  handleClose() {
    this.toggle(false);
  }

  toggle(flag?: boolean, callback?: any) {
    const { isOpen } = this.state;
    if (flag === isOpen) {
      return;
    }

    this.setState(
      prevState => ({
        isOpen: isBoolean(flag) ? flag : !prevState.isOpen,
      }),
      () => {
        const { onToggle } = this.props;
        onToggle?.(this.state.isOpen);

        if (isFunction(callback)) {
          callback();
        }
      }
    );
  }

  render() {
    const { headRenderer, contentRenderer, ...props } = this.props;
    const { isOpen } = this.state;

    return (
      <OnClickOutside
        {...props}
        onClickOutside={this.handleClose}
        onBlur={this.handleBlur}
        onFocus={this.handleFocus}
      >
        <StyledHeader functional onClick={this.handleClick}>
          {headRenderer()}
        </StyledHeader>
        {isOpen && (
          <StyledContentContainer ref={this.dropdownRef}>
            {React.cloneElement(contentRenderer() as React.ReactElement<any>, {
              tabIndex: 0,
            })}
          </StyledContentContainer>
        )}
      </OnClickOutside>
    );
  }
}

const StyledHeader = styled(Button)`
  width: 100%;
`;

const StyledContentContainer = styled.div`
  position: relative;
`;

AbstractDropdown.StyledContentContainer = StyledContentContainer;

export default AbstractDropdown;
